import React from 'react';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

// This component represents the whole right hand side panel on Desktop;
// And represents the top panel above center panel on Mobile/Tablet
const RightPanelOrTopPanel = (props) => {
  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo} />
          </div>
          <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
        </div>
      </Container>
    </div>
  );
};

export default RightPanelOrTopPanel;
